import React from 'react';
import i18next from 'i18next';

interface Props {
  intervals: { interval: string, key: string }[],
  selectedInterval: string,
  inverseStyle: boolean,
  onClick: any
}

const IntervalBox = ({
  intervals, onClick, selectedInterval
}: Props) => (
    <div className="intervalBox">
      {
        intervals.map(item => (
          <div className={item.key === selectedInterval ? 'selectedInterval' : 'interval'}
            key={item.key}
            onClick={() => onClick(item.key)}>
            {i18next.t('Chart.' + item.key, '')}
          </div>
        ))
      }
    </div>
  )

export default IntervalBox